import {
  amscompanyAccessPointAction,
  amscompanyAccessGroupAction,
  amssynccompanyAccessGroupAction,
  amsVendorSyncAccessUsersAction,
  clientSettingsAction
} from "./amsSlice";
import { apiSliceAMSManager } from "../api/apiSlice";

export const amsApi = apiSliceAMSManager.injectEndpoints({
  endpoints: (builder) => ({
    getAMSCompanyAccessPoint: builder.query({
      query: ({ companyId }) =>
        `AccessPoint/getCompanyAccessPoints?companyId=${companyId ?? ""}`,
      async onQueryStarted({}, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result.data?.length > 0) {
            dispatch(
              amscompanyAccessPointAction({
                amscompanyAccessPointList: result.data,
              })
            );
          }
        } catch (err) {}
      },
    }),

    createCustomAccessGroup: builder.query({
      query: (body) => ({
        url: "AmsvendorSync/createCustomAccessGroup",
        method: "POST",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
        } catch (err) {
          console.log(err);
        }
      },
    }),

    getAMSSyncAccessGroup: builder.query({
      query: ({ companyId }) =>
        `AmsvendorSync/getAccessGroups?companyId=${companyId ?? ""}`,
      async onQueryStarted({}, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result.data?.length > 0) {
            dispatch(
              amssynccompanyAccessGroupAction({
                amssynccompanyAccessGroupList: result.data,
              })
            );
          }
        } catch (err) {}
      },
    }),

    deleteCustomAccessGroup: builder.query({
      query: (body) => ({
        url: "AmsvendorSync/deleteCustomAccessGroup",
        method: "DELETE",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
        } catch (err) {
          console.log(err);
        }
      },
    }),

    removeCustomAccessGroupPropertyUnits: builder.query({
      query: (body) => ({
        url: "AmsvendorSync/removeCustomAccessGroupPropertyUnits",
        method: "DELETE",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
        } catch (err) {
          console.log(err);
        }
      },
    }),

    removeCustomAccessGroupUser: builder.query({
      query: (body) => ({
        url: "AmsvendorSync/removeCustomAccessGroupUser",
        method: "DELETE",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
        } catch (err) {
          console.log(err);
        }
      },
    }),

    addEditCustomAccessGroupAccessPoints: builder.query({
      query: (body) => ({
        url: "AmsvendorSync/addEditCustomAccessGroupAccessPoints",
        method: "POST",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
        } catch (err) {
          console.log(err);
        }
      },
    }),

    addDirectUsers: builder.query({
      query: (body) => ({
        url: "AmsvendorSync/addDirectUsers",
        method: "POST",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
        } catch (err) {
          console.log(err);
        }
      },
    }),

    getAMSVendorAccessGroupDetailById: builder.query({
      query: ({ request }) =>
        `AmsvendorSync/getAMSVendorAccessGroupDetailById?AccessGroupDetail=${request ?? ""}`,
      async onQueryStarted({}, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
        } catch (err) {}
      },
    }),

    addCustomPropertyUnits: builder.query({
      query: (body) => ({
        url: "AmsvendorSync/addCustomPropertyUnits",
        method: "POST",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
        } catch (err) {
          console.log(err);
        }
      },
    }),

    getAMSVendorSyncAccessUsers: builder.query({
      query: ({ companyId }) =>
        `AmsvendorSync/getAMSVendorSyncAccessUsers?companyId=${companyId ?? ""}`,
      async onQueryStarted({}, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result.data?.length > 0) {
            dispatch(
              amsVendorSyncAccessUsersAction({
                amsVendorSyncAccessUsersList: result.data,
              })
            );
          }
        } catch (err) {}
      },
    }),

    deleteAMSUser: builder.query({
      query: (body) => ({
        url: "AmsvendorSync/deleteUser",
        method: "POST",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
        } catch (err) {
          console.log(err);
        }
      },
    }),

    addClientSettings: builder.query({
      query: (body) => ({
        url: "Organization/addClientSettings",
        method: "POST",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
        } catch (err) {
          console.log(err);
        }
      },
    }),

    getClientSettings: builder.query({
      query: ({ companyId }) =>
        `Organization/getClientSettings?companyId=${companyId ?? ""}`,
      async onQueryStarted({}, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result.data) {
            let data = result.data;
            dispatch(
              clientSettingsAction({
                privacyMode : data.privacyMode,
                dashboard : data.dashboard,
                units : data.units,
                accessgroups : data.accessgroups,
                accesspoints : data.accesspoints
              })
            );
          }
          else{
            dispatch(
              clientSettingsAction({
                privacyMode : false,
                dashboard : '',
                units : '',
                accessgroups : '',
                accesspoints : ''
              })
             );
          }
        } catch (err) {}
      },
    }),

    addEditAccessPoint: builder.query({
      query: (body) => ({
        url: "AmsvendorSync/addEditAccessPoint",
        method: "POST",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
        } catch (err) {
          console.log(err);
        }
      },
    }),

    getAccessPointDetail: builder.query({
      query: ({ vendorAccessPointId,companyId }) =>
        `AmsvendorSync/getAccessPointDetail?vendorAccessPointId=${vendorAccessPointId ?? 0}&companyId=${
          companyId ?? 0
        }`,
      async onQueryStarted({}, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result.data?.length > 0) {
          }
        } catch (err) {}
      },
    }),

    updateAmsUser: builder.mutation({
      query: ({ userId, body }) => ({
        url: `users/${userId}`,
        method: "PATCH",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
        } catch (err) {
          console.error("Update AMS user failed:", err);
        }
      },
    }),

    createAmsUsers: builder.mutation({
      query: (body) => ({
        url: `AmsvendorSync/createUsers`,
        method: "POST",
        body,
      }),
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          console.error("Create/Update AMS user failed:", err);
        }
      },
    }),



  }),
});

export const {
  useLazyGetAMSCompanyAccessPointListQuery,
  useLazyGetAMScompanyAccessGroupListQuery,
  useLazyGetAMSSyncAccessGroupQuery,
  useLazyCreateCustomAccessGroupQuery,
  useLazyDeleteCustomAccessGroupQuery,
  useLazyRemoveCustomAccessGroupPropertyUnitsQuery,
  useLazyRemoveCustomAccessGroupUserQuery,
  useLazyAddEditCustomAccessGroupAccessPointsQuery,
  useLazyAddDirectUsersQuery,
  useLazyGetAMSVendorAccessGroupDetailByIdQuery,
  useLazyAddCustomPropertyUnitsQuery,
  useLazyGetAMSVendorSyncAccessUsersQuery,
  useLazyDeleteAMSUserQuery,
  useLazyAddClientSettingsQuery,
  useLazyGetClientSettingsQuery,
  useLazyAddEditAccessPointQuery,
  useLazyUpdateAMSUser,
  useCreateAmsUsersMutation
} = amsApi;
